import { call } from 'redux-saga/effects';

// STORE
import { pushErrorNotification } from '@/utility/snackbar';

export function* showErrorNotification(error) {
  const errorStatus = error.response?.status;

  if (!(errorStatus === 519 || errorStatus === 499)) {
    yield call(pushErrorNotification, error);
  }
}

export default showErrorNotification;
